import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FeatherModule } from "angular-feather";
import { TranslateModule } from "@ngx-translate/core";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CommonModule } from '@angular/common';
import { BadgeGiftsDescriptionDumbComponent } from './badge-gifts-description/badge-gifts-description.dumb.component';

@Component({
  selector: 'app-badge-gifts',
  templateUrl: './badge-gifts.component.html',
  styleUrls: ['./badge-gifts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FeatherModule, TranslateModule, TooltipModule, CommonModule, BadgeGiftsDescriptionDumbComponent],
  host: { class: 'd-flex flex-row align-items-center' }
})
export class BadgeGiftsComponent {
  @Input() enableTooltip: boolean;

  preventRoutingActions($event: any): void {
    $event.stopPropagation();
    $event.preventDefault();
  }

}
